import { useQuery } from '@apollo/client';
import { createError } from '@common/neo.tax';

import {
  GET_ASC_PROJECT_GROUPING_TICKETS_OR_COLLECTIONS,
  GetAscProjectGroupingTicketsOrCollectionsQuery,
  GetAscProjectGroupingTicketsOrCollectionsQueryVariables,
  PeriodName,
} from '@neo.tax/shared';

export type AscGroupingTicketOrCollection =
  GetAscProjectGroupingTicketsOrCollectionsQuery['getAscProjectGroupingTicketsOrCollections'][number];

type UseAscProjectGroupingTicketsOrCollectionsResult =
  | {
      data: GetAscProjectGroupingTicketsOrCollectionsQuery['getAscProjectGroupingTicketsOrCollections'];
      loading: false;
    }
  | {
      loading: true;
      data: null;
    };

export const useAscProjectGroupingTicketsOrCollections = ({
  ascProjectId,
  fiscalYearId,
  periodName,
  searchKeyword,
}: {
  ascProjectId: string;
  fiscalYearId: string;
  periodName: PeriodName;
  searchKeyword?: string | null;
}): UseAscProjectGroupingTicketsOrCollectionsResult => {
  const { data, error, loading } = useQuery<
    GetAscProjectGroupingTicketsOrCollectionsQuery,
    GetAscProjectGroupingTicketsOrCollectionsQueryVariables
  >(GET_ASC_PROJECT_GROUPING_TICKETS_OR_COLLECTIONS, {
    variables: { ascProjectId, fiscalYearId, periodName, searchKeyword: searchKeyword || undefined },
  });

  if (loading) {
    return { loading: true, data: null };
  }

  if (error) {
    throw error;
  }

  if (!data) {
    throw createError('MissingDataError', `useAscProjectGroupingTicketsOrCollections ${ascProjectId}`);
  }

  return { loading: false, data: data?.getAscProjectGroupingTicketsOrCollections };
};
